import React, { useEffect } from "react";
import { useLocalStore } from "easy-peasy";
import { Typography, Box } from "@mui/material";
import { OutlinedBtn } from "components/admin_v2/ui/Buttons";
import BreadCrumbs from "components/admin_v2/common/BreadCrumbs";
import Spinner from "components/admin_v2/ui/Spinner";
import TopPageLayout from "components/admin_v2/nav/TopPageLayout";
import SchoolConfigTabs from "components/admin_v2/school_config/SchoolConfigTabs";
import StaffForm from "components/admin_v2/school_config/staff/StaffForm";
import I18n from "utils/i18n.js";
import { usersStore } from "components/admin_v2/common/stores/usersStore";
import { pageRoutes } from "services/api";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const StaffEdit = (props) => {
  const cls = useCommonPageStyles();
  const [state, actions] = useLocalStore(() => usersStore({ role: "school_staff" }));
  const user = state.user;
  const id = props.match.params.id;

  useEffect(() => {
    if (!id) return;

    actions.fetchUser(id);

    return () => {
      actions.setUser(null);
    };
  }, [id]);

  return (
    <React.Fragment>
      <TopPageLayout title={I18n.t("school_config.title")} />
      <SchoolConfigTabs />
      <BreadCrumbs path={pageRoutes.staffs()} label={I18n.t("school_config.staffs.breadcrumb")} />
      {user && (
        <Box className={cls.titleWithBtn}>
          <Typography variant="h1" gutterBottom>
            {user.name}
          </Typography>
          <Box className={cls.btnsWrapper}>
            <OutlinedBtn className={cls.actionBtn} onClick={() => actions.resetPassword(id)}>
              {I18n.t("ui.btn.reset_password")}
            </OutlinedBtn>
            <OutlinedBtn className={`${cls.actionBtn} active`} disabled>
              {I18n.t("school_config.edit_staff.btn")}
            </OutlinedBtn>
            <OutlinedBtn className={cls.actionBtn} onClick={() => actions.toggleArchive(id)}>
              {user.discarded ? I18n.t("ui.btn.unarchive") : I18n.t("ui.btn.archive")}
            </OutlinedBtn>
          </Box>
        </Box>
      )}
      {state.loading ? <Spinner /> : <StaffForm user={user} />}
    </React.Fragment>
  );
};

export default StaffEdit;
